module.exports = __webpack_public_path__ + "assets/bicycle_active-0b2dbf.svg";